var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3,
    fill: "#003393"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 15,
    height: 15,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 12,
    height: 4,
    rx: 0.5,
    fill: "#003393"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 10,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 10,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 12.75,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 15.5,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12.75,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15.5,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.75,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 15.5,
    width: 3.5,
    height: 1.75,
    rx: 0.5,
    fill: "#003393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCalculator);
export default __webpack_public_path__ + "static/media/priceCalculator.332e35a1eeb61571e098517759feafee.svg";
export { ForwardRef as ReactComponent };